import { ChatProspectStage } from '@/types';
import { ManagerRepTimeRange } from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';

export const EMPTY_VALUE_PLACEHOLDER = '—';

export const SEARCHBAR_MAX_WIDTH = 642;

export const PROSPECT_STAGE_FILTER_ORDER: ChatProspectStage[] = [
  ChatProspectStage.Cold,
  ChatProspectStage.Discovery,
  ChatProspectStage.Engaged,
  ChatProspectStage.Quote,
  ChatProspectStage.Won,
];

export const PROSPECT_STAGE_TRANSLATION_KEYS: Record<
  ChatProspectStage,
  string
> = {
  [ChatProspectStage.Cold]: 'sales_portal.prospects.stage.cold',
  [ChatProspectStage.Discovery]: 'sales_portal.prospects.stage.discovery',
  [ChatProspectStage.Engaged]: 'sales_portal.prospects.stage.engaged',
  [ChatProspectStage.New]: 'sales_portal.prospects.stage.new',
  [ChatProspectStage.Quote]: 'sales_portal.prospects.stage.quote',
  [ChatProspectStage.Won]: 'sales_portal.prospects.stage.won',
};

export const LAST_ACTIVITY_ALERT_INDICATOR_DAYS = 30;

export const MANAGER_FORECAST_WINDOWS_IN_DAYS = [7, 30, 60];

export const MANAGER_PIPELINE_BAR_MAX_HEIGHT = 56;

export const MANAGER_PIPELINE_BAR_MIN_HEIGHT = 4;

export const MANAGER_PIPELINE_COLUMN_HEIGHT = 105;

export const MANAGER_PIPELINE_SKELETON_COLUMNS = 5;

export const MANAGER_PIPELINE_STAGE_LABEL_HEIGHT = 18;

export const REP_TIME_RANGE_OPTIONS: ManagerRepTimeRange[] = [
  ManagerRepTimeRange.Wtd,
  ManagerRepTimeRange.Mtd,
  ManagerRepTimeRange.Ytd,
];

export const REP_TIME_RANGE_LABEL_KEYS: Record<ManagerRepTimeRange, string> = {
  [ManagerRepTimeRange.Mtd]: 'sales_portal.prospects.manager.time_range.mtd',
  [ManagerRepTimeRange.Wtd]: 'sales_portal.prospects.manager.time_range.wtd',
  [ManagerRepTimeRange.Ytd]: 'sales_portal.prospects.manager.time_range.ytd',
};
